import { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import { DropdownMenu } from './DropdownMenu';
import { DropdownMenuButton } from '../DropdownMenuButton/DropdownMenuButton';
import { DropdownMenuWrapper } from './DropdownMenuWrapper';

import './DropdownWithMenu.scss';

export const DropdownWithMenu = (props) => {
  const {
    menuData,
    defaultValue,
    defaultChosenValue,
    dropdownChangeHandler = () => {},
    extendClass = '',
    extendMenuClass = '',
    singleColumn,
    hideDefaultItem,
    disableDefaultItem,
    updatedChosenValue = '',
  } = props;
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [chosenValue, setChosenValue] = useState('');
  const classes = `dropdown-with-menu ${extendClass}`;

  useEffect(() => {
    if (defaultChosenValue) {
      setChosenValue(defaultChosenValue);
    }
  }, [updatedChosenValue]);

  useEffect(() => {
    setChosenValue(defaultChosenValue);
  }, []);

  const menuButtonClickHandler = () => {
    setIsMenuOpen((prevState) => !prevState);
  };

  const menuItemClickedHandler = (chosenValues) => {
    const { itemName, itemId = null } = chosenValues;
    setChosenValue(itemName);
    dropdownChangeHandler(itemId);
    setIsMenuOpen(false);
  };

  return (
    <DropdownMenuWrapper isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} className={classes}>
      <DropdownMenuButton
        isMenuOpen={isMenuOpen}
        menuButtonClickHandler={menuButtonClickHandler}
        defaultValue={defaultValue}
        chosenValue={chosenValue}
      />
      <DropdownMenu
        isMenuOpen={isMenuOpen}
        menuData={menuData}
        defaultValue={defaultValue}
        chosenValue={chosenValue}
        menuItemClickedHandler={menuItemClickedHandler}
        singleColumn={singleColumn}
        hideDefaultItem={hideDefaultItem}
        disableDefaultItem={disableDefaultItem}
        extendClass={extendMenuClass}
      />
    </DropdownMenuWrapper>
  );
};

DropdownWithMenu.propTypes = {
  defaultValue: PropTypes.string,
  defaultChosenValue: PropTypes.string,
  menuData: PropTypes.array,
  dropdownChangeHandler: PropTypes.func,
  extendClass: PropTypes.string,
  extendMenuClass: PropTypes.string,
  singleColumn: PropTypes.bool,
  hideDefaultItem: PropTypes.bool,
  disableDefaultItem: PropTypes.bool,
  updatedChosenValue: PropTypes.string,
};
